import { useEffect, useState } from "react";
import { getProject } from '../functions/Queries';
import Loader from '../components/Loader/Loader';
import ImageView from '../components/ImageView/ImageView';
import { useLocation } from "react-router-dom";
import { fire, fireDatabase, fireFunctions} from "../config/firebase";
import Admin from "./Admin/Admin";
import SuperAdmin from "./Admin/SuperAdmin";
import { getAuth, signInAnonymously } from "firebase/auth";
import { httpsCallable } from "firebase/functions";
import { ref, set } from "firebase/database";

// fire.functions().useEmulator("localhost", 5001);


// A custom hook that builds on useLocation to parse
// the query string for you.
function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const View = (props) => {
    const [loading, setLoading] = useState(true);
    const [project, updateProject] = useState(false);
    const [imageSize, updateImageSize] = useState(false);
    const [activeImg, updateActiveImage] = useState('image1');

    let query = useQuery();
    const projectID = props.projectId || query.get("id");
    const layout = query.get("layout");
    const lang = query.get("lang") || "sv";

    if(!window.location.pathname.includes('admin')){
        document.getElementsByTagName('body')[0].classList.add('locked');
    }
    
    if (layout) {
        document.getElementsByTagName('body')[0].classList.add(layout);
    }
    if (lang) {
        document.getElementsByTagName('html')[0].setAttribute('lang', lang);
    }

    function getProjectData(){
        getProject(projectID, updateProject, setLoading, handleError)
    }

    async function handleError(){

        const auth = await getAuth(fire);
        const user = auth.currentUser;
        console.log('| | | | | | | | | | | | | | | | | | | | | | | | ');
        console.log('usr:', user);

        getProjectData();



    }

    useEffect(() => {
        if (projectID) {
            getProjectData();     
        }
    }, [])

    function handleHouseClick(houseID, ip_adress){
        const ip = ip_adress.split('.').join('-');

        if(!ip)return false

        let newData = {...project.items[houseID]};
        if (newData.users) {
            let clickInfo = newData.users[ip] || { clicks: 0 };
            clickInfo.clicks++;

            newData.users[ip] = clickInfo;
        }
        else {
            let clickInfo = { clicks: 1 };
            newData.users = {};
            newData.users[ip] = clickInfo;
        }

        // const handleHouseClick = httpsCallable(fireFunctions, 'handleHouseClick');

        set(ref(fireDatabase, `projects/${projectID}/items/${newData.id}/users`), newData.users);


        // handleHouseClick({ projectID: projectID, ip: ip, itemData: newData})
        //     .catch(err => console.error(err));
    }

    return (
        <>
            {loading && projectID ?
                <>
                    <Loader />
                    Hämtar projekt ...
                </>
                :
                <>
                    {!projectID || !project ?
                        <>
                            {props.admin ? 
                                <SuperAdmin />
                            :   
                                <>
                                Hoppsan, du behöver ange en korrekt url.
                                </>
                            }
                        </>
                        :
                        <>
                            {props.admin ? 
                                <Admin imageSize={imageSize} data={project} onLogin={getProjectData} activeImg={activeImg} projectID={projectID} updateActiveImg={updateActiveImage}>
                                    <ImageView getProjectData={getProjectData} setImageSize={updateImageSize} projectID={projectID} admin={props.admin} data={project} activeImg={activeImg} updateActiveImage={updateActiveImage} />
                                </Admin>
                            :
                                <>
                                <ImageView getProjectData={getProjectData} onHouseClick={handleHouseClick} projectID={projectID} admin={props.admin} data={project} activeImg={activeImg} updateActiveImage={updateActiveImage} />
                                {props.children}
                                <div className={(loading && projectID) ? 'loading' : 'loading loaded'}></div>
                                </>
                            }

                        </>

                    }
                </>
            }
        </>

    )
}

export default View;